import React from 'react'

const Report = props => (
  <svg width={props.width ? props.width : '24'}
       height={props.height ? props.height : '24'}
       fill={props.color ? props.color : '#97A3C7'}
       viewBox="0 0 24 24"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M11.0014 10.0001H13.0014V15.0001H11.0014V10.0001Z"/>
    <path
      d="M12.0014 16.0001C11.4491 16.0001 11.0014 16.4478 11.0014 17.0001C11.0014 17.5524 11.4491 18.0001 12.0014 18.0001C12.5537 18.0001 13.0014 17.5524 13.0014 17.0001C13.0014 16.4478 12.5537 16.0001 12.0014 16.0001Z"
    />
    <path fillRule="evenodd" clipRule="evenodd"
          d="M2.73587 21.0022C1.96554 21.0022 1.48448 20.1678 1.87044 19.5012L11.136 3.49701C11.5212 2.83173 12.4817 2.83172 12.8668 3.49701L22.1324 19.5011C22.5184 20.1678 22.0373 21.0022 21.267 21.0022H2.73587ZM19.5325 19.0022L12.0014 5.99391L4.47032 19.0022H19.5325Z"
    />
    <path d="M11.0014 16.0001H13.0014V18.0001H11.0014V16.0001Z"/>
  </svg>

)

export default Report
